import React from 'react';
import { Hero } from '../components/home/Hero';
import { ServicesOverview } from '../components/home/ServicesOverview';
import { CaseStudy } from '../components/home/CaseStudy';
import { HowWeWork } from '../components/home/HowWeWork';
import { Testimonials } from '../components/home/Testimonials';
import { CTA } from '../components/home/CTA';

export const Home = () => {
  return (
    <div className="bg-[rgb(17,17,19)]">
      <Hero />
      <ServicesOverview />
      <CaseStudy />
      <HowWeWork />
      <Testimonials />
      <CTA />
    </div>
  );
};
